import { Injector, NgModule, isDevMode } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { ServiceLocator } from './models/locator.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularDeviceInformationService } from 'angular-device-information';
import { environment } from 'src/environments/environment';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from './shared/shared.module';
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { MsalModule, MsalRedirectComponent, MsalGuard, MsalInterceptor, MsalService } from "@azure/msal-angular";

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

let deviceversion: number = 0;

@NgModule({
  declarations: [AppComponent, SpinnerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    NgSelectModule,
    HammerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    SharedModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: environment.msalConfig.auth,
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: isIE,
        },
      }),
      {
        interactionType: InteractionType.Redirect, // Msal Guard Configuration
        authRequest: {
          scopes: environment.msalConfig.loginScope,
        },
      },
      {
        interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
        protectedResourceMap: new Map([
          ["https://graph.microsoft.com/v1.0/me", environment.msalConfig.loginScope]
        ]),
      }
    ),
  ],
  exports: [
    SpinnerComponent
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy, },
  { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true, },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true, },
    MsalGuard,
    AngularDeviceInformationService],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {
  constructor(private injector: Injector, private device: AngularDeviceInformationService, private msalService: MsalService) {    // Create global Service Injector.
    this.msalService.instance.initialize();
    ServiceLocator.injector = this.injector;
    deviceversion = device.getDeviceInfo().osVersion;
  }
}

